/// <amd-module name="Repos/Tfvc/Views/ShelvesetDetails/ShelvesetDiscussionIntegrationService" />
import {
    ArtifactDiscussionIntegrationService,
    IArtifactDiscussionIntegrationService
} from "Repos/Artifact/Discussion/ArtifactDiscussionIntegrationService";
import { IArtifactDiscussionThreadService } from "Repos/Artifact/Discussion/ArtifactDiscussionThreadService";
import { getMarkdownEditorProps } from "Repos/Artifact/Discussion/CommonMarkdownProps";
import { IDiscussionMarkdownEditorProps } from "Repos/Discussion/DiscussionThread.Types";
import { IVssPageContext, Services } from "VSS/Platform/Context";
import { getDiscussionThreadService } from "./ShelvesetDiscussionThreadService";

export interface IShelvesetDiscussionIntegrationService extends IArtifactDiscussionIntegrationService {}

class ShelvesetDiscussionIntegrationService extends ArtifactDiscussionIntegrationService implements IShelvesetDiscussionIntegrationService {
    protected getDiscussionStore(pageContext: IVssPageContext): IArtifactDiscussionThreadService {
        return getDiscussionThreadService(pageContext);
    }

    protected getMarkdownEditorProps(): IDiscussionMarkdownEditorProps {
        return getMarkdownEditorProps("ms.vss-code-web.shelveset-detail-markdown-commands");
    }
}

const serviceName = "IShelvesetDiscussionIntegrationService";
export function getDiscussionIntegrationService(pageContext: IVssPageContext): IShelvesetDiscussionIntegrationService {
    return pageContext.getService(serviceName);
}

Services.add(serviceName, { serviceFactory: ShelvesetDiscussionIntegrationService });
